import React from 'react';

import Background from '@app/components/UI/Background/Background';
import EmailForm from '@app/components/UI/ContactForms/EmailForm/EmailForm';
import ReviewForm from '@app/components/UI/ContactForms/ReviewForm/ReviewForm';
import HelmetProvider from '@app/components/UI/Helmet/HelmetCustom';
import Media from '@app/components/UI/Media/Media';
import Tabs from '@app/components/UI/Tabs/Tabs';

import '@app/scss/components/contactForm.scss';
import '@app/scss/pages/contacts.scss';

const FormContacts: React.FC<{ isReview }> = ({ isReview }) => {
	return (
		<div className="contact-form">
			<h2 className="text-center">{isReview ? 'Want to leave a book/speaking review?' : 'Email Dr. Mary'}</h2>
			{isReview ? <ReviewForm /> : <EmailForm textDone="Thank you for your speaking request. We will reach out to you shortly!" />}
		</div>
	);
};

const Contacts: React.FC = () => {
	const [tab, setTab] = React.useState('1');
	return (
		<HelmetProvider title="Contact">
			<div className="contacts-page is-relative pages">
				<Background />
				<div className="container">
					<h2 className="text-center">Contact</h2>
					<Tabs
						onTabChange={setTab}
						items={[
							{
								key: '1',
								label: 'Email Dr. Mary',
								children: '',
							},
							{
								key: '2',
								label: 'Leave a book or speaking review',
								children: '',
							},
						]}
					/>
					<FormContacts isReview={tab === '2'} />
					<div className="contact-links">
						<Media />
					</div>
				</div>
			</div>
		</HelmetProvider>
	);
};

export default Contacts;
